import { BannerInformation } from 'components/bannerInformation';
import { formatPrice } from 'features/carrello/utils';
import styles from './CarrelloFooterVincitaInfoRow.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useMemo } from 'react';

export type CarrelloFooterVincitaInfoRowProps = {
  label: string;
  value: string;
  bonus?: number;
  bonusLabel?: string;
  bonusValue?: string;
  warningLabel?: string;
  hasOnlyHorizontalPadding?: boolean;
};

export const CarrelloFooterVincitaInfoRow = ({
  label,
  value,
  bonus,
  bonusLabel,
  bonusValue,
  warningLabel,
  hasOnlyHorizontalPadding,
}: CarrelloFooterVincitaInfoRowProps) => {
  return (
    <div className={`${styles.container} ${hasOnlyHorizontalPadding ? styles.hasOnlyHorizontalPadding : ''}`}>
      <p className={styles.paragraph}>
        <span>{label}</span>
        <span className={styles.bold}>{formatPrice(value)} €</span>
      </p>
      {!!bonus && bonus > 0 && bonusLabel && <BonusParagraph bonusLabel={bonusLabel} bonusValue={bonusValue} />}
      {/* TODO implementare logica di visualizzazione */}
      {warningLabel && <BannerInformation text={warningLabel} type="warning" visible={false} layoutType="onlylabel" />}
    </div>
  );
};

export const BonusParagraph = ({
  bonusLabel,
  bonusValue,
  hasPadding,
}: {
  bonusLabel: string;
  bonusValue?: string;
  hasPadding?: boolean;
}) => {
  return (
    <p className={`${styles.paragraph} ${styles.bonusParagraph} ${hasPadding && styles.hasPadding}`}>
      <span>{bonusLabel}</span>
      {bonusValue && <span className={styles.bold}>{formatPrice(bonusValue)} €</span>}
    </p>
  );
};

export const TaxParagraph = ({
  hasPadding,
  percApplicata = 0,
  percReale = 0,
  quota = 0,
  isMultipla,
}: {
  hasPadding?: boolean;
  percReale?: number;
  percApplicata?: number;
  quota?: number;
  isMultipla?: boolean;
}) => {
  const labelTaxes = useGetLabelByKey('taxes');
  const labelTaxFree = useGetLabelByKey('tax-free');
  const promotionalMessage = useGetLabelByKey('promotional-message-tax-free');

  const taxes = useMemo(() => {
    return percApplicata ? String((quota * percApplicata) / 100) : '0';
  }, [percApplicata, quota]);

  const taxesReal = useMemo(() => {
    return percReale ? String((quota * percReale) / 100) : '0';
  }, [percReale, quota]);

  return percApplicata ? (
    <div className={styles.containerTax}>
      <p className={`${styles.paragraph} ${hasPadding ? styles.paddingParagraph : ''}`}>
        <span className={styles.taxesParagraph}>{labelTaxes}</span>
        {taxes && <span className={styles.bold}>{formatPrice(taxes)} €</span>}
      </p>
      {isMultipla === false && (
        <div className={`${hasPadding ? styles.paddingParagraph : ''}`}>
          <p
            className={`${styles.taxesParagraph} ${styles.accent} ${styles.bgCombination} ${styles.paddingSubParagraph}`}
          >
            {promotionalMessage}
          </p>
        </div>
      )}
    </div>
  ) : (
    <div className={styles.containerTax}>
      <p className={`${styles.paragraph} ${hasPadding ? styles.paddingParagraph : ''}`}>
        <span className={`${styles.taxesParagraph} ${styles.accent}`}>{labelTaxFree}</span>
        <div className={styles.containerTaxes}>
          {taxesReal && <span className={`${styles.bold} ${styles.taxesReal}`}>{formatPrice(taxesReal)} €</span>}
          <span className={styles.bold}>{formatPrice('0')} € (0%)</span>
        </div>
      </p>
    </div>
  );
};
